'use strict';

module.exports = function (marty) {
  marty.createConstants = require('./constants');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/constants/index.js
 ** module id = 548
 ** module chunks = 0
 **/